import React from 'react';
import { GrGoogle } from "react-icons/gr";
import { TiVendorMicrosoft } from "react-icons/ti";
import { FaMeta } from "react-icons/fa6";
import { FaAmazon } from "react-icons/fa";
import { FaApple } from "react-icons/fa";
import { TbBrandNetflix } from "react-icons/tb";
import { SiFlipkart } from "react-icons/si";
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BigCard from './BigCard';

import { useState, useEffect, useRef } from 'react';



const ProductSlider = () => {

  var settings = {
    dots: true,
    infinite: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // enable autoplay
    autoplaySpeed: 2000,
  };


  const imgs = [
   
    {   url:  '5.jpeg',h1:`Crazy deals`,h2:`Buy 1 get 1`,p:`The best classic dress is on sale at NestMart` },
    {   url:  '2.jpeg',h1:`Cool Tops`,h2:`T-Shirts`,p:`New trendy t-shirts for this summer`  },
    {   url:  '3.jpeg',h1:`Women / Men`,h2:`Winter collection`,p:`Buy best jackets for men and women both`  },
    {   url:  '4.jpeg',h1:`Summer / Spring`,h2:`Upcoming season`,p:`The best classic dress is on sale at NestMart`  },
    {   url:  '1.jpeg',h1:`50 % off`,h2:`Sale is live`,p:`The best classic dressess is on sale`  },
  ];



  return (
    <div className="w-full">
     
      <Slider {...settings}>

      {imgs.map((d, index) => (
              
        <BigCard key={index} img={d.url} h1={d.h1} h2={d.h2} p={d.p}/>
            
         ))}
      </Slider>
    </div>
  );
};

export default ProductSlider;
